import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/index.vue'
import Poster from '@/views/poster/index.vue'
import buyCar from '@/views/buyCar/index.vue'
import Lottery from '@/views/lottery/index.vue'
import RecommendOld from '@/views/recommend/index.vue'
import Recommend from '@/views/recommend/national-agent.vue'
import RecommendApp from '@/views/recommend/national-agent-app.vue'
import Questionnaire from '@/views/questionnaire/new-questionnaire.vue'
import QuestionnairePreview from '@/views/questionnaire/questionnaire-preview.vue'
import Cut from '@/views/cut/index.vue'
import Vote from '@/views/vote/index.vue'
import IntegralIndex from '@/views/integral/index.vue'
import IntegralShare from '@/views/integral/share.vue'
import NationalDayIndex from '@/views/national-day/index.vue'
import NationalDayShare from '@/views/national-day/share.vue'
import CarryIndex from '@/views/carry/index.vue'
import ElevenIndex from '@/views/eleven/index.vue'
import ElevenShare from '@/views/eleven/share.vue'
import BlankPage from '@/views/blankPage.vue'
import FinanceZone from '@/views/finance-zone/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: '测试页面'
    }
  },
  {
    path: '/blankPage',
    name: 'BlankPage',
    component: BlankPage,
    meta: {
      title: '空白页面'
    }
  },
  {
    path: '/poster',
    name: 'Poster',
    component: Poster,
    meta: {
      title: ''
    }
  },
  {
    path: '/buyCar',
    name: 'buyCar',
    component: buyCar,
    meta: {
      title: ''
    }
  },
  {
    path: '/lottery',
    name: 'Lottery',
    component: Lottery,
    meta: {
      title: '大转盘测试'
    }
  },
  {
    path: '/recommend',
    name: 'RecommendOld',
    component: RecommendOld,
    meta: {
      title: '推荐有礼'
    }
  },
  {
    path: '/recommend-new',
    name: 'Recommend',
    component: Recommend,
    meta: {
      title: '全民代理'
    }
  },
  {
    path: '/recommend-app',
    name: 'RecommendApp',
    component: RecommendApp,
    meta: {
      title: '全民代理-app'
    }
  },
  {
    path: '/questionnaire',
    name: 'Questionnaire',
    component: Questionnaire,
    meta: {
      title: '问卷'
    }
  },
  {
    path: '/questionnaire-preview',
    name: 'QuestionnairePreview',
    component: QuestionnairePreview,
    meta: {
      title: '问卷预览'
    }
  },
  {
    path: '/vote',
    name: 'Vote',
    component: Vote,
    meta: {
      title: '投票'
    }
  },
  {
    path: '/cut',
    name: 'Cut',
    component: Cut,
    meta: {
      title: '砍价帮帮忙'
    }
  },
  {
    path: '/integral/index',
    name: 'Integral',
    component: IntegralIndex,
    meta: {
      title: '迎中秋 赚积分'
    }
  },
  {
    path: '/integral/share',
    name: 'IntegralShare',
    component: IntegralShare,
    meta: {
      title: '迎中秋 赚积分'
    }
  },
  {
    path: '/national-day/index',
    name: 'nationalDay',
    component: NationalDayIndex,
    meta: {
      title: '国庆七天乐 积分赚不停'
    }
  },
  {
    path: '/national-day/share',
    name: 'nationalDayShare',
    component: NationalDayShare,
    meta: {
      title: '国庆七天乐 积分赚不停'
    }
  },
  {
    path: '/carry/index',
    name: 'carryIndex',
    component: CarryIndex,
    meta: {
      title: '精品货源'
    }
  },
  {
    path: '/eleven/index',
    name: 'elevenIndex',
    component: ElevenIndex,
    meta: {
      title: '助力双十一 积分赚不停'
    }
  },
  {
    path: '/eleven/share',
    name: 'elevenShare',
    component: ElevenShare,
    meta: {
      title: '助力双十一 积分赚不停'
    }
  },
  {
    path: '/finance-zone',
    name: 'financeZone',
    component: FinanceZone,
    meta: {
      title: '金融专区'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/jac-direct-mall-activity-h5/',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
